module.exports = __webpack_public_path__ + "assets/img/bj.6fe2fbc9.png";